import { OverviewPanel } from '@/components/ui/OverviewPanel';
import { formatCents, formatDateTime, formatInteger } from '@/lib/format';

export interface UserValuePanelProps {
  pointsBalance: number;
  visitCount: number;
  spendCents: unknown;
  tipCents: unknown;
  lastVisitAt?: string | null;
}

/**
 * `user_value_stats` summary. Sits above the tabs because it is the number an
 * operator wants on screen whichever tab they are working in.
 */
export function UserValuePanel({
  pointsBalance,
  visitCount,
  spendCents,
  tipCents,
  lastVisitAt,
}: UserValuePanelProps) {
  return (
    <div className="space-y-2">
      <OverviewPanel
        title="Loyalty & value"
        stats={[
          {
            id: 'points',
            label: 'Points',
            value: formatInteger(pointsBalance),
          },
          { id: 'visits', label: 'Visits', value: formatInteger(visitCount) },
          {
            id: 'spend',
            label: 'Spend',
            value: formatCents(spendCents as number),
          },
          { id: 'tips', label: 'Tips', value: formatCents(tipCents as number) },
        ]}
      />
      <p className="text-xs text-gray-500 dark:text-gray-400">
        Last visit {formatDateTime(lastVisitAt)}. Points are global; vouchers
        are scoped. Crossing a threshold mints a voucher; redeeming it at the
        bar spends the snapshotted points.
      </p>
    </div>
  );
}
